import { assign } from 'lodash';
import config from './config';
import WizzeeLog from './lib/wizzeeLog';

const replaceObjectWith = (oldObject, newObject) => {
  Object.keys(oldObject).forEach(key => delete oldObject[key]);
  assign(oldObject, newObject);
};

/* eslint-enable */

let themes;
const currentTheme = {};
let currentThemeIndex;
let themeSwitchEnabled;

export function loadThemes(newThemes) {
  themes = newThemes;
  currentThemeIndex = 0;
  replaceObjectWith(currentTheme, themes[0]);
  themeSwitchEnabled = themes.length > 1;
}

loadThemes(config.themes);
export default currentTheme;
export { currentTheme, themeSwitchEnabled };

export function changeTheme() {
  if (!themeSwitchEnabled) {
    return currentTheme.name;
  }
  currentThemeIndex = (currentThemeIndex + 1) % themes.length;
  replaceObjectWith(currentTheme, themes[currentThemeIndex]);
  return currentTheme.name;
}

export function setTheme(themeName) {
  currentThemeIndex = themes.findIndex(theme => theme.name === themeName);
  if (currentThemeIndex !== -1) {
    replaceObjectWith(currentTheme, themes[currentThemeIndex]);
  } else {
    WizzeeLog.warn('Could not find theme', themeName);
  }
  return currentTheme.name;
}

export function getUsageStyle(usage, theme) {
  return theme.usages.hasOwnProperty(usage) ? theme.usages[usage] : theme.usages.DEFAULT;
}

export function getCatalogStyle(unitType, theme) {
  if (unitType.includes('ROA') && unitType.includes('DATA')) {
    return theme.catalog.hasOwnProperty('ROA_DATA') ? theme.catalog.ROA_DATA : theme.catalog.DEFAULT;
  }
  return theme.catalog.hasOwnProperty(unitType) ? theme.catalog[unitType] : theme.catalog.DEFAULT;
}